<template>
  <div class="component guest-picker">
    <div :class="{overlay : modalActive}" @click="onOkay"></div>

    <form-input type="text" icon="guest" :label="$t('guest-picker.label')" :readonly="true" autocomplete="off" :value="label" @focus="activate"/>

    <div class="picker-modal" v-bind:class="{ active: modalActive }">
      <div class="content-wrapper">
        <ul class="pax">
          <li v-for="pax in enabled" :key="pax" :class="pax">
            <div class="meta">
              <div class="label">{{ paxLabels[pax] }}</div>
              <div class="price" v-if="pricing">{{ $formatter.currency(pricing[pax]) }}</div>
            </div>
            <quantity-picker :value="paxProp(pax)" @input="val => paxProp(pax, val)" :max="paxMax(pax)"/>
          </li>
        </ul>

        <div class="actions">
          <button @click="onCancel">{{ $t('picker-modal.cancel') }}</button>
          <button class="primary" @click="onOkay">{{ $t('picker-modal.ok') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuantityPicker from '@/components/QuantityPicker.vue';
import FormInput from '@/components/FormInput.vue';
import ModalMixin from '@/mixins/modal';

export default {
  mixins: [ ModalMixin ],

  components: {
    FormInput,
    QuantityPicker
  },
  
  props: {
    value: Object,
    max: Number,
    enabled: {
      type: Array,
      default: () => ['seniors', 'adults', 'students', 'children', 'infants']
    },  
    paxPrefix: {
      type: String,
      default: ''
    },
    pricing: Object
  },

  created() {
    this.onCreate();  // this is defined in the mixin
  },  

  data() {
    let d = { modalStateKeys: this.enabled };
    let v = this.value || {};
    this.enabled.forEach(key => d[key] = v[key] || 0);
    d.allowScrolling = true;
    return d;
  },

  computed: {
    label() {
      let items = [];

      this.enabled.forEach(key => {
        let v = this[key];
        if (v > 0) {
          items.push(v + ' ' + this.calculateLabel(key, v));
        }
      });

      return items.join(', ');
    },

    inputActive() {
      return true;
    },

    total() {
      return this.enabled.reduce((total, key) => total + this[key], 0);
    },

    paxLabels() {
      let labels = {};
      this.enabled.forEach(pax => {
        labels[pax] = this.calculateLabel(pax);
      });

      return labels;
    },
  },

  methods: {
    save() {
      this.$emit('input', this.getValue());
    },

    reset() {
      let v = this.value || {};
      this.enabled.forEach(key => this[key] = v[key] || 0);
    },

    calculateLabel(pax, c = 2) {
      let key = `${this.paxPrefix}guest-picker.${pax}`;
      let label = this.$tc(key, c);
      if (key === label) {
        // we didn't find a label so fall back to no prefix
        label = this.$tc(`guest-picker.${pax}`, c);
      }
      return label;
    },

    paxProp(key, val=null) {
      if (val !== null) {
        this[key] = val;
      }
      return this[key];
    },

    paxMax(key) {
      return this.max === undefined ? undefined : this.max - (this.total - this[key]);
    },
  }
};
</script>

<style lang="scss">
.guest-picker, .availability-calendar {
  @include breakpoint(medium) {
    position: relative;
  }

  .picker-modal {
    .content-wrapper {
      background-color: #fff;
      border-radius: 3px;
      -webkit-box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.15);
      box-shadow: 0 2px 5px 2px rgba(0, 0, 0, 0.15);
      z-index: 999;
      width: 250px;
      margin-top: -20px;
      margin-left: 40px;
      position: absolute;

      ul.pax {
        @include unlisted;
        padding: 20px 20px 0 20px;

        li {
          display: flex;
          align-items: center;
          margin-bottom: 14px;
        }

        .meta {
          margin: 0;
          width: calc(100% - 115px);

          .label {
            font-size: 16px;
          }
          .price {
            color: $colorGray;
          }
        }

        .quantity-picker {
          margin: 0;
          width: 100px;
          margin-left: 15px;
        }
      }
  
      dl {
        display: flex;
        flex-wrap: wrap;
        align-items: center;

        dt {
          width: calc(100% - 115px);

          .label {
            font-size: 16px;
          }
          .price {
            color: $colorGray;
          }
        }

        dd {
          margin: 0;
          width: 100px;
          margin-left: 15px;
        }

        dt,dd {
          margin-bottom: 14px;
        }
      }
    }

    &.active {
      &::before {
        content: "";
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 998;
        @include breakpoint(medium) {
          content: none;
        }
      }
      
      .content-wrapper {
        @include breakpoint(medium) {
          position: absolute;
          left: -40px;
          right: unset;
          transform: none;
          width: 250px;
          padding: 0;
        }
      }
    }
  }
}

.overlay {
  content: '';
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
}
</style>